import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import WebapiCommon from '@util/webapi.common';
import * as commonActions from '@common/common.action';

function DefaultDataItens () {
  const dispatch = useDispatch();

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = () => {
    WebapiCommon.obterDadosGeraisHospital().then(resp =>
      dispatch(commonActions.dadosGeraisHospital(resp))
    );
    WebapiCommon.getMedicos().then(resp =>
      dispatch(commonActions.preencherMedicos(resp))
    );
    WebapiCommon.obterUsuarios().then(resp =>
      dispatch(commonActions.preenhcerUsuarios(resp))
    );
  };
  return <div />;
}

export default DefaultDataItens;



// WEBPACK FOOTER //
// ./src/componentes/DefaultDataItens/index.js